<template>
  <div>
    <v-dialog
      v-model="open"
      content-class="privacy"
      max-width="800px"
      scrollable="scrollable"
    >
      <div class="relative px-4 py-6 white policy-privacy-card">
        <div class="text-h5 font-weight-bold text-md-h4 pb-2 text-center">
          Política de Privacidade
        </div>
        <div class="policy-privacy-content">
          <PolicyPrivacyContent class="mt-4" />
        </div>
        <v-btn
          @click="open = false"
          class="mt-n1"
          color="red"
          icon="icon"
          absolute="absolute"
          top="top"
          right="right"
          small
        >
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import PolicyPrivacyContent from "./../content/PolicyPrivacyContent.vue";

export default {
  data: () => ({
    value: false,
    open: false,
  }),
  methods: {
    showPrivacy() {
      this.open = true;
    },
  },
  created() {
    window.showPrivacyPolicy = () => this.showPrivacy();
  },
  components: {
    PolicyPrivacyContent,
  },
};
</script>

<style>
.policy-privacy-card {
  overflow: hidden;
}

.policy-privacy-content {
  overflow-y: scroll;
  height: calc(100% - 24px);
}

.relative {
  position: relative;
}
</style>
